import React from 'react';
import './App.css';
import HomeScreen from "./HomeScreen.js";

function App() {
  return (
    <div className="app">
      <HomeScreen />
    </div>
  );
}

export default App;
